/* "Clear all" in the cart drawer header. See snippets/kodo-cart-clear.liquid.

   Asks for the drawer's markup in the same request as the clear, then fires the
   theme's `cart:update` so the drawer re-renders from the server. Same shape as
   kodo-cart-add.js, including firing the event only once the button's own DOM
   work is done. */
(function () {
  if (window.__kodoCartClear) return;
  window.__kodoCartClear = true;

  const shopRoot = () =>
    (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  document.addEventListener('click', async (event) => {
    const btn = event.target.closest('[data-kodo-clear]');
    if (!btn || btn.disabled) return;

    event.preventDefault();
    btn.disabled = true;

    const body = {};
    const cartItems = document.querySelector('cart-items-component');
    const sectionId = cartItems && cartItems.dataset.sectionId;
    if (sectionId) body.sections = sectionId;

    let cleared;
    try {
      const res = await fetch(shopRoot() + 'cart/clear.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(body),
      });
      if (!res.ok) throw new Error('clear failed');
      cleared = await res.json();
    } catch (err) {
      btn.disabled = false;
      return;
    }

    document.dispatchEvent(
      new CustomEvent('cart:update', {
        bubbles: true,
        detail: {
          resource: cleared,
          sourceId: 'kodo-cart-clear',
          data: {
            source: 'cart-items-component',
            itemCount: 0,
            sections: cleared && cleared.sections,
          },
        },
      })
    );

    // Harmless if the drawer already replaced this node during its re-render.
    btn.disabled = false;
  });
})();
